import { useQuery } from '@tanstack/react-query';

import { getExternalChatConfig } from '@/services/external-chat/config';
import { unwrap } from '@/services/external-chat/detail-error';
import type { ExternalChatConfigResponse } from '@/services/external-chat/types';

export const externalChatConfigQueryKey = (
  orgId?: string,
  collectionId?: string,
) => ['external-chat-config', orgId, collectionId];

export const useExternalChatConfig = (orgId?: string, collectionId?: string) =>
  useQuery<ExternalChatConfigResponse, Error>({
    queryKey: externalChatConfigQueryKey(orgId, collectionId),
    queryFn: async () => unwrap(await getExternalChatConfig(collectionId!)),
    enabled: !!orgId && !!collectionId,
  });
